import React from 'react';
import { Button, Heading, Modal, Paragraph } from '../Ant';
import { Flex } from 'antd';
import {
  MODAL_CANCEL_BUTTON_MAX_WIDTH,
  MODAL_CONFIRM_BUTTON_MAX_WIDTH,
} from '../../constants/constants';
interface CustomModalProps {
  visible: boolean;
  onClose?: () => void;
  title: string;
  description?: string;
  subdescription?: string;
  cancelText?: string;
  confirmText?: string;
  onConfirm?: () => void;
  icon?: React.ReactNode;
}

const CustomModal: React.FC<CustomModalProps> = ({
  visible,
  onClose,
  title,
  description,
  subdescription,
  cancelText,
  confirmText,
  onConfirm,
  icon,
}) => {
  const hasBothActions = !!cancelText && !!confirmText;

  return (
    <Modal
      className="confirm-modal"
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={370}
      closeIcon={null}
      data-testid="custom-modal"
    >
      <Flex gap={15} vertical align="center">
        {icon && <div className="icon-container">{icon}</div>}
        <div>
          <Heading
            level={6}
            $fontsize="14px"
            $color="title"
            $mb={5}
            $weight={600}
            $lineheight="18px"
            className="ta-center"
            data-testid="information-popup-title"
          >
            {title}
          </Heading>
          {description && (
            <Paragraph
              data-testid="information-popup-description"
              $fontsize="13px"
              className="ta-center"
              $color="description"
              $lineheight="20px"
            >
              {description}
            </Paragraph>
          )}
          {subdescription && (
            <Paragraph
              data-testid="information-popup-subdescription"
              $fontsize="13px"
              className="ta-center"
              $color="description"
              $lineheight="20px"
            >
              {subdescription}
            </Paragraph>
          )}
        </div>
        <Flex gap={5} className="w-full">
          {cancelText && (
            <Button
              data-testid="custom-modal-cancel-button"
              type="default"
              block
              onClick={onClose}
              size="large"
              maxwidth={hasBothActions ? MODAL_CANCEL_BUTTON_MAX_WIDTH : undefined}
            >
              {cancelText}
            </Button>
          )}
          {confirmText && (
            <Button
              data-testid="custom-modal-confirm-button"
              type="primary"
              block
              onClick={onConfirm}
              size="large"
              maxwidth={hasBothActions ? MODAL_CONFIRM_BUTTON_MAX_WIDTH : undefined}
            >
              {confirmText}
            </Button>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CustomModal;
